import getCookie from 'lib/cookie/getCookie';
import setCookie from 'lib/cookie/setCookie';
import {setLocalStorage, getLocalStorage} from 'lib/localStorage';
const merge = require('lodash/merge');
const detectBrowser = require('a_common-folder/utils/detectBrowser');

export function cloneCanvas(canvas) {

    var newCanvas = document.createElement('canvas');
    var context = newCanvas.getContext('2d');

    newCanvas.width = canvas.width;
    newCanvas.height = canvas.height;

    context.drawImage(canvas, 0, 0);

    return newCanvas;
}

export function blobToDataURL(blob) {
    return new Promise((res, rej) => {
        var a = new FileReader();
        a.onload = function(e) {res(e.target.result);}
        a.readAsDataURL(blob);
    })
}

export function addCanvasWebWorker () {
    var blob = new Blob([
        document.querySelector('#worker-offscreen-canvas').textContent
    ], { type: "text/javascript" })

    var worker = new Worker(window.URL.createObjectURL(blob));

    return worker;
}

export function sendFrames(frame) {
    if (window.parent) {
        window.parent.postMessage({frame: frame, type: 'frame'}, '*');
    }
}

export function sendProgress(progress) {
    if (window.parent) {
        window.parent.postMessage({progress: progress}, '*');
    }
}

export function aggregation (baseClass, ...mixins) {
    class base extends baseClass {
        constructor (...args) {
            super(...args);
            mixins.forEach((mixin) => {
                copyProps(this,(new mixin));
            });
        }
    }
    let copyProps = (target, source) => {  // this function copies all properties and symbols, filtering out some special ones
        Object.getOwnPropertyNames(source)
            .concat(Object.getOwnPropertySymbols(source))
            .forEach((prop) => {
                if (!prop.match(/^(?:constructor|prototype|arguments|caller|name|bind|call|apply|toString|length)$/))
                    Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop));
            })
    }
    mixins.forEach((mixin) => { // outside contructor() to allow aggregation(A,B,C).staticFunction() to be called etc.
        copyProps(base.prototype, mixin.prototype);
        copyProps(base, mixin);
    });
    return base;
}

let isHostVR = window.location.host.match(/^[^.]+\.([^.]+)\.vr-360-tour.com$/);

export const servInstance = isHostVR ? isHostVR[1] + '_' : '';

export function delay(delay){
    return new Promise((res, rej) => {
        setTimeout(() => res(), delay * 1000)
    })
}
export function prepareOptions(defaultOptions, inputOptions) {
    let options = Object.assign({}, defaultOptions);

    Object.keys(defaultOptions).forEach((key) => {
        if (!inputOptions.hasOwnProperty(key)) return;

        options[key] = Array.isArray(options[key])
            ? options[key].concat(inputOptions[key])
            : inputOptions[key];
    });

    return options;
}

export function sortByAltitude(layers){
    let byAltitude = !Array.isArray(layers) ? Object.values(layers.toJS()).slice(0) : layers;
    byAltitude.sort(function(a,b) {
        return a.altitude - b.altitude;
    });

    return byAltitude;
}

export function getPathId(){
    return window.location.pathname.substring(3, window.location.pathname.lastIndexOf('/'));
}

function getAllInfoIconStyle(style, id, config){
    let infoIconStyles = getLocalStorage('infoIconStyles') || '[]';
    const iconsStyle = [];

    Object.entries(localStorage).forEach((local) => {
        if(local[0].match(/infoIconStyles/)){
            const infoId = local[0].split('_').pop();
            const pathId = local[0].match(/(.*?)\_infoIconStyles/)[1];

            if(pathId === getPathId()){
                iconsStyle.push({id: infoId, style: JSON.parse(local[1])});
            }
        }
    })

    return iconsStyle || '[]';
}

export function updateInfoIconStyle(style, id, config){
    if(style && id && !config){
        const isUrl = style.match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi);

        if(isUrl && isUrl[0]){
            const urlPath = getPathId();
            setLocalStorage(`${urlPath}_infoIconStyles_${id}`, JSON.stringify(style));
        }
    }

    let infoIconsStyles = getAllInfoIconStyle();
    infoIconsStyles.push({id, style});
    infoIconsStyles.forEach(({style, id}) => {
        const info = document.body.querySelector(`.info-${id}`);
        const infoImg = document.body.querySelector(`.info-${id} img`);
        const infoContainer = document.body.querySelector(`.info-${id} .e3-viewer-poi-info-container`);


        if(!info) return;

        const customSpan = info.querySelector('.icon-custom-span');
        if(customSpan) info.removeChild(customSpan);

        for(let y in style.icon){
            // if(detectBrowser.isIE && y === 'content') {
            if(y === 'content') {
                let url = style.icon[y].match( /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi)[0];
                url = url.replace(')' , '');
                const span = document.createElement('span');
                span.style.setProperty('background',  `${style.icon[y]} no-repeat` , 'important');
                span.style.setProperty('width',  `100%`);
                span.style.setProperty('height',  `100%`);
                span.style.setProperty('position',  `absolute`);
                span.style.setProperty('top',  `0`);
                span.style.setProperty('left',  `0`);
                span.style.setProperty('transform',  `translate(-50%, -50%);`);
                span.className = ' icon-custom-span';

                infoImg.style.opacity = 0;
                info.appendChild(span);
                info.classList.add('user-icon');

                var image = new Image();
                image.crossOrigin = 'anonymous';
                image.onload = function() {
                    info.style.width = `${this.width}px`;
                    info.style.height = `${this.height}px`;
                };
                image.src = url;

            }else{
                infoImg.style.setProperty(y, style.icon[y], 'important');
            }
            if(y === 'content'){
                info.classList.remove(`icon-default`);
            }
        }

        if(infoContainer){
            for(let y in style.body){
                infoContainer.style.setProperty(y, style.body[y], 'important');
            }
        }

        info.classList.add('icon-custom');
    })
}

export function validURL(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
}

export function generateUUID(){
    let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });

    return uuid;
}

export function loadJsFile(url, props) {
    return new Promise((res, rej) => {
        let script = document.createElement('script');
        script.setAttribute('src', url);
        script.setAttribute('type', 'text/javascript');
        let loaded = false;
        if(props){
            props.forEach((val) => {
                script.setAttribute(...val);
            })
        }
        let loadFunction = function () {
            if (loaded) return;
            loaded = true;
            res();
        };
        script.onload = loadFunction;
        script.onreadystatechange = loadFunction;
        document.getElementsByTagName("head")[0].appendChild(script);
    })
};

export const base64ToBuffer = (base64) => {
    var binstr = atob(base64);
    var buf = new Uint8Array(binstr.length);
    Array.prototype.forEach.call(binstr, function (ch, i) {
        buf[i] = ch.charCodeAt(0);
    });
    return buf;
}
